import { useProductDetailState } from 'contexts';
import { MAX_ITEMS_WITH_TWO_BLOCKS, RelatedBlock } from './RelatedBlock';

export const RelatedVideos = () => {
  const { product } = useProductDetailState();

  const { relatedVideos } = product?.seoInfo || {};

  if (!relatedVideos?.urls?.length) {
    return null;
  }

  return (
    <RelatedBlock
      title={relatedVideos?.title || ''}
      seeMoreUrl={relatedVideos?.seeMoreUrl}
      type="video"
      items={
        relatedVideos?.urls
          ?.slice(0, MAX_ITEMS_WITH_TWO_BLOCKS)
          .map(({ url, thumbnailUrl, description }) => {
            return {
              url: url || '',
              thumbnailUrl: thumbnailUrl || '',
              description: description || '',
            };
          }) || []
      }
    />
  );
};
